import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  reportItem: {
    "& span": {
      fontFamily: "Manrope",
      fontStyle: "normal",
      fontWeight: 700,
      fontSize: "18px",
      lineHeight: "140%",
      color: "#344054",
    },
  },
  reportFavoriteItems: {
    margin: "16px 0 24px 0",
  },
  itemReport: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "16px 24px",
    gap: "16px",
    border: "1px solid #E4E7EC",
    borderRadius: "8px",
    cursor: "pointer",
  },
  itemReportDescription: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: 0,
    gap: "2px",
  },
  reportTitle: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "150%",
    color: "#465869",
  },
  reportDropdown: {
    display: "flex",
    gap: "24px",
    paddingLeft: 0,
  },
  collapseContainer: {
    width: "100%",
  },
  favoriteIcon: {
    padding: "5px",
  },
  reportWrapper: {
    padding: "8px 16px 8px 0 !important",
  },
}));

export default styles;
